App.BusinessRoleTableRowComponent = Em.Component.extend
  env:     Em.inject.service('environment')
  session: Em.inject.service('session')

  tagName: 'tr'
  businessRole: null
  currentUser: null

  handleClick: (->
    @sendAction 'onBusinessRoleClicked', @get('businessRole')
  ).on('click')
